<template>
  <div>
    <div v-if="showClear && alerts.length!==0">
      <BButton variant="outline-danger"
               size="sm"
               @click="clearAlerts"
               class="mt-2">
        <BIconTrash2Fill/> <B>경보 전체 삭제</B>
      </BButton>
    </div>

    <b-list-group class="mt-2 alert-scroll" :style="{ maxHeight }">
      <b-list-group-item v-for="(e,idx) in alerts" :key="idx"
                         class="flex-column align-items-start border-warning mb-1">
        <div class="d-flex w-100 justify-content-between">
          <BBadge class="font-sm" style="min-width:64px"
                  :variant="eventColor[e.code]">
            {{ e.name }}
          </BBadge>

          <BBadge class="font-sm" :class="{ blink: getDiffSeconds(e.dt) < 60 }">
            {{ e.tnm }}
          </BBadge>

          <i class="small font-sm">{{ toShortTime(e.dt) }}</i>
          <BBadge variant="info" class="btn"
                  @click="delayAlert(e,idx)">
            <BIconCheck/>
          </BBadge>
          <BBadge variant="dark" class="btn"
                  @click="removeAlert(idx)">
            <BIconTrash/>
          </BBadge>
        </div>

        <BRow class="mt-1 small text-wrap">
          <BCol>
            {{ e.text?.split('|').slice(1).toString() }}
          </BCol>
        </BRow>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import '@/common/HelperMixin';
import { apiCall, getDiffSeconds, loadSuppressAlarms } from '@/common/utils';
import { EVENT_COLOR } from '@/common/constants';

export default {
  name: 'AlarmAlertList',
  props: {
    // 목록 스크롤 영역 최대 높이
    maxHeight: { type: String, default: '400px' },
    // 전체 삭제 버튼 표시 여부. 상위에서 카드 헤더에 따로 둘 때 false
    showClear: { type: Boolean, default: true },
    // 알람 확인(체크) 시 적용할 지연 시간(분)
    delayMin: { type: Number, default: 10 },
  },
  data () {
    return {
      eventColor: EVENT_COLOR,
    }
  },
  computed: {
    // 경보 목록은 스토어 공유. 소켓 수신은 TheAside 한 곳에서만 처리한다.
    alerts(){
      return this.$store.state.alarm.alerts;
    },
  },
  methods: {
    getDiffSeconds,

    clearAlerts(){
      this.alerts.splice(0);
    },

    removeAlert(idx){
      this.alerts.splice(idx,1);
    },

    /** 알람 확인 = 해당 탱크/경보를 지정 시간만큼 지연 설정하고 목록에서 제거 */
    async delayAlert(e, idx){
      try{
        const r = await apiCall('put', `/api/alarm/suppress`, {
          tid: e.tid,
          evtCode: e.code,
          min: this.delayMin,
        });

        if(r.code===200){
          await loadSuppressAlarms();
          const tankName = this.$store.state.tanks['map'][e.tid]?.name || e.tnm;
          await this.toastInfo(`탱크 ${tankName} ${e.name}, ${this.delayMin}분 지연설정 완료`, '경보 지연설정');
        }else{
          await this.toastResult(r);
        }
      }catch(err){
        console.error(err);
      }finally{
        this.alerts.splice(idx,1);
      }
    },
  }
}
</script>

<style scoped>
.alert-scroll {
  overflow-y: auto;
}
</style>
